export default __webpack_public_path__ + "static/media/Armguards of the Haunter in the Dark.7fb669e8.jpg";